export const PERMISSION_DASHBOARD_VIEW = "dashboard.view";
export const PERMISSION_DASHBOARDACCESSRULE_READ = "dashboardAccessRule.read";
export const PERMISSION_DASHBOARDACCESSRULE_UPDATE = "dashboardAccessRule.update";
export const PERMISSION_DASHBOARDACCESSRULE_VIEW = "dashboardAccessRule.view";
